import { render, staticRenderFns } from "./educationDivision.vue?vue&type=template&id=3ef5aa62"
import script from "./educationDivision.vue?vue&type=script&lang=js"
export * from "./educationDivision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ef5aa62')) {
      api.createRecord('3ef5aa62', component.options)
    } else {
      api.reload('3ef5aa62', component.options)
    }
    module.hot.accept("./educationDivision.vue?vue&type=template&id=3ef5aa62", function () {
      api.rerender('3ef5aa62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/div/educationDivision.vue"
export default component.exports